import { FC, PropsWithChildren } from 'react';

import { Box, Stack } from '@mui/material';

import { useIsMobileShell } from '@/shared/lib/useIsMobileShell';

import { APPBAR_HEIGHT, SIDEBAR_WIDTH } from '@/shared/ui/constants';

interface IProps {
  sidebar: React.ReactNode;
}

/**
 * Основной лэйаут с навигацией.
 * @param root0 Пропсы
 * @param root0.children Дочерние элементы
 * @param root0.sidebar Навигация (рельса или AppBar+Drawer)
 */
export const LayoutWithSidebar: FC<PropsWithChildren<IProps>> = ({
  children,
  sidebar
}) => {
  const isMobile = useIsMobileShell();

  return (
    <Stack flex={1} overflow='hidden'>
      {sidebar}

      <Box
        flex={1}
        display='flex'
        ml={isMobile ? 0 : `${SIDEBAR_WIDTH}px`}
        mt={isMobile ? `${APPBAR_HEIGHT}px` : 0}
        overflow='auto'
      >
        {children}
      </Box>
    </Stack>
  );
};
